import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  width: 100%;

  .range-container {
    width: ${props => props.width};
  }

  & .input-zone {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 350px;
  }

  input {
    width: 56px;
    height: 27px;
    box-sizing: border-box;
    border: 1px solid #cecece;
    outline: none;
    font-size: 14px;
    margin: 20px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 0;
    padding: 2px;
    text-align: center;
    background: transparent;
  }
`;

const handleStyle = {
  width: 42,
  height: 42,
  marginTop: -18,
  marginLeft: -22,
  border: `2px solid ${colors.greyTwo}`,
  backgroundColor: colors.offWhite
};

const trackStyle = {
  backgroundColor: colors.slider,
  height: 3
};

const railStyle = {
  backgroundColor: colors.borderSelect,
  height: 3
};

export { Wrapper, handleStyle, trackStyle, railStyle };



// WEBPACK FOOTER //
// ./src/components/YearSelect/style.js